import { EventType } from './EventType';
import { RequiredConditionalMandatory } from './RequiredConditionalMandatory';
import { EventTypeLevel } from './EventTypeLevel';
import { RotationTreeEnum } from '../../enums/rotationTreeEnum';
import { EventTypeGroupConfigChange } from './EventTypeGroupConfigChange';

export class EventTypeGroup {
    constructor(
        eventTypeGroupId: number,
        name: string,
        mandatory: boolean,
        multiple: boolean,
        concurrent: boolean,
        generateConcurrentId: boolean,
        showInPlanView: boolean,
        ordered: boolean,
        mainInLevel: boolean,
        insideLevelBoundary: boolean,
        nextGroupInLevelId: number | null,
        requiredPreviousTypeId: number | null,
        requiredPreviousSameTypeId: number | null,
        eventTypeArray: EventType[],
        icon: string | null,
        notAfterEventTypeId: number | null,
        levelId: RotationTreeEnum | null,
        requiredConditionalMandatoryArray: RequiredConditionalMandatory[] | null,
        deleted: boolean,
        enabledFrom: Date | null,
        useInSimpleMode: boolean | null,
        onlyUseInSimpleMode: boolean | null
    ) {
        this.eventTypeGroupId = eventTypeGroupId;
        this.name = name;
        this.mandatory = mandatory;
        this.multiple = multiple;
        this.concurrent = concurrent;
        if (multiple) {
            this.generateConcurrentId = true;
        } else {
            this.generateConcurrentId = generateConcurrentId;
        }
        this.showInPlanView = showInPlanView;
        this.ordered = ordered;
        this.mainInLevel = mainInLevel;
        this.insideLevelBoundary = insideLevelBoundary;
        this.nextGroupInLevelId = nextGroupInLevelId;
        this.requiredPreviousTypeId = requiredPreviousTypeId;
        this.requiredPreviousSameTypeId = requiredPreviousSameTypeId;
        this.eventTypeArray = eventTypeArray;
        this.icon = icon;
        this.notAfterEventTypeId = notAfterEventTypeId;
        this.levelId = levelId;
        this.requiredConditionalMandatoryArray = requiredConditionalMandatoryArray;
        this.deleted = deleted;
        this.enabledFrom = enabledFrom;
        this.useInSimpleMode = useInSimpleMode;
        this.onlyUseInSimpleMode = onlyUseInSimpleMode;
        this.eventTypeLevel = null;
        //this.crossNodeCondtion = null;
        this.crossPortCallPreviousEvTypeGroupList = [];
        this.crossPortCallNextEvTypeGroupList = [];
        this.imosPortFunctionMapList = [];
        this.eventTypeGroupConfigChangeList = [];
    }
    eventTypeGroupId: number;
    name: string;
    mandatory: boolean;
    multiple: boolean;
    concurrent: boolean;
    generateConcurrentId: boolean;
    showInPlanView: boolean;
    ordered: boolean;
    mainInLevel: boolean;
    insideLevelBoundary: boolean;
    nextGroupInLevelId: number | null;
    requiredPreviousTypeId: number | null;
    requiredPreviousSameTypeId: number | null;
    eventTypeArray: EventType[];
    icon: string | null;
    notAfterEventTypeId: number | null;
    eventTypeLevel: EventTypeLevel | null;
    levelId: RotationTreeEnum | null;
    requiredConditionalMandatoryArray: RequiredConditionalMandatory[] | null;
    deleted: boolean;
    useInSimpleMode: boolean | null;
    onlyUseInSimpleMode: boolean | null;
    enabledFrom: Date | null;
    // crossNodeCondtion: CrossNodeCondition | null;
    crossPortCallPreviousEvTypeGroupList: number[];
    crossPortCallNextEvTypeGroupList: number[];
    imosPortFunctionMapList: string[];
    eventTypeGroupConfigChangeList: EventTypeGroupConfigChange[];
}
